import { List, Map as ImmutableMap, Record } from 'immutable';
import * as ActionTypes from 'automation-ui-action-features/constants/ActionTypes';
import PropertyValue from 'automation-ui-flow-core/fields/PropertyValue';
import * as FormulaActionMetadataKeys from 'automation-ui-action-features/actions/formula/FormulaActionMetadataKeys';
import getLangLocale from 'I18n/utils/getLangLocale';
export default class FormulaActionMetadata extends Record({
  [FormulaActionMetadataKeys.ACTION_TYPE]: ActionTypes.FORMULA,
  [FormulaActionMetadataKeys.TEMPLATE]: '',
  [FormulaActionMetadataKeys.VARIABLE_CONTEXT]: List(),
  [FormulaActionMetadataKeys.LANGUAGE_TAG]: getLangLocale()
}, 'FormulaActionMetadata') {
  constructor(props) {
    const propMap = ImmutableMap(props);
    super(propMap.update(FormulaActionMetadataKeys.VARIABLE_CONTEXT, variableContexts => {
      const typedVariableContexts = variableContexts;
      return List(typedVariableContexts).map(variableContext => ImmutableMap(variableContext).update('value', value => new PropertyValue(value)));
    }));
  }
  getVariableContexts() {
    return this[FormulaActionMetadataKeys.VARIABLE_CONTEXT];
  }
}